<template lang="pug">
.contieneTexto
	.titular {{texto.Titular}}
	.lead {{texto.Lead}}
	.contenido(v-html="texto.Texto")
</template>

<script>
export default {
	props: ['texto']
}
</script>

<style scoped>
.contieneTexto {
	max-width: 210mm;
	padding: 10px;
	background-color: white;
	box-shadow: 0 0 10px rgba(0,0,0,0.2);
	border-radius: 3px;
}

.titular {
	font-size: 2em;
	font-weight: bold;
	margin-bottom: 20px;
	line-height: 1.5em;
}

.lead {
	text-align: justify;
	font-size: 1.2em;
	line-height: 1.5em;
	padding-bottom: 10px;
	margin-bottom: 10px;
	border-bottom: 1px solid #e0e0e0;
}

.contenido {
	text-align: justify;
	line-height: 1.5em;
	font-size: 1.2em;
}
</style>



// WEBPACK FOOTER //
// src/modulos/redaccion/vue/componentes/editor/visor-texto.vue